export default __webpack_public_path__ + "b8a4008ab6f119930854d422d6bd39b9.jpg";